import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, submit } from 'redux-form/immutable';
import { AutoComplete } from 'redux-form-material-ui';
import { AutoComplete as MUIAutoComplete } from 'material-ui';
import FlatButton from 'material-ui/FlatButton';
import _ from 'lodash';

import ReduxDialog from '../Common/ReduxDialog';
import { getDialogContextProp } from '../../reducers/helper';
import { toJSSafe, splitCamelCase, countries, id } from '../../utils/helper';
import { renderTextField } from '../../utils/reduxforms.js';

import styles from './styles';
import commonStyles from '../styles';

const validate = (values) => {
  const valuesObj = values.toJS();
  const errors = {};
  const requiredFields = ['line1', 'city', 'state', 'country'];
  requiredFields.forEach((field) => {
    if (!valuesObj[field]) {
      errors[field] = `Require a ${splitCamelCase(field)} field`;
    }
  });
  return errors;
};

class AddressDialog extends React.Component {
  static propTypes = {
    onRequestClose: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
  };

  state = {};

  render() {
    const { handleSubmit, initialValues } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.onRequestClose()}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => this.props.submit()}
      />,
    ];

    return (
      <ReduxDialog
        name="address"
        title={initialValues && initialValues.get('id') ? initialValues.get('line1') : 'Create New Address'}
        actions={actions}
        modal={false}
        onRequestClose={this.handleClose}
        bodyStyle={styles.body}
      >
        <form onSubmit={handleSubmit}>
          <Field
            name="name"
            component={renderTextField}
            floatingLabelText="Name"
            floatingLabelFixed
            fullWidth
            style={commonStyles.input}
          />
          <Field
            name="line1"
            component={renderTextField}
            floatingLabelText="Address Line 1"
            floatingLabelFixed
            fullWidth
            style={commonStyles.input}
          />
          <Field
            name="line2"
            component={renderTextField}
            floatingLabelText="Address Line 2"
            floatingLabelFixed
            fullWidth
            style={commonStyles.input}
          />
          {/* <Field*/}
          {/* name="building"*/}
          {/* component={TextField}*/}
          {/* floatingLabelText="Building"*/}
          {/* floatingLabelFixed*/}
          {/* fullWidth*/}
          {/* style={commonStyles.input}*/}
          {/* />*/}
          <div style={styles.row}>
            <Field
              name="city"
              component={renderTextField}
              floatingLabelText="City"
              floatingLabelFixed
              fullWidth
              style={commonStyles.input}
            />
            <Field
              name="state"
              component={renderTextField}
              floatingLabelText="State"
              floatingLabelFixed
              fullWidth
              style={commonStyles.input}
            />
          </div>
          <div style={styles.row}>
            <Field
              name="postalCode"
              component={renderTextField}
              floatingLabelText="Postal Code"
              floatingLabelFixed
              fullWidth
              style={commonStyles.input}
            />
            <Field
              component={AutoComplete}
              dataSource={countries}
              openOnFocus
              filter={MUIAutoComplete.caseInsensitiveFilter}
              className="autocomplete"
              onNewRequest={(e) => { this.setState({ country: e.id }); }}
              name="country"
              floatingLabelText="Country"
              floatingLabelFixed
              fullWidth
              style={commonStyles.input}
            />
          </div>
          <Field
            name="Notes"
            component={renderTextField}
            floatingLabelText="Notes"
            floatingLabelFixed
            fullWidth
            style={commonStyles.input}
            multiLine
            rows={3}
          />
        </form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'address',  // a unique identifier for this form
  enableReinitialize: true,
  validate,
  onSubmit: (values, dispatch, props) => {
    props.onRequestClose(_.assign({ id: id() }, values.toJS()));
  },
})(AddressDialog);

function mapStateToProps(state) {
  return {
    initialValues: getDialogContextProp(state.get('dialogs').get('dialogs'), 'address', 'address'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit: () => submit('address'),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/AddressDialog/index.js